import { CardSection } from './CardSection';

// TODO: in v9, move styled() from CardSection.jsx to here
export var StyledCardSection = CardSection;